
import React, { useState,useEffect,useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import './carddaydisplay.css'




import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {
    Input,
    Col,
    Row,
  } from "reactstrap";

import 'rc-slider/assets/index.css';



const HeartRateMonitor = (props) => {
  const {
    buttonLabel,
    className
  } = props;


  const dispatch = useDispatch()

  const [time,setTime] = useState(0)
  const [beats,setBeats] = useState(0)
  const [start,setStart] = useState(false)
  const countRef = useRef(null)
  const [modal, setModal] = useState(false);

  
  const monitor = () =>{
    if (start === false){
        setStart(true)
        countRef.current = setInterval(() => {
            setTime((time) => time + 1)
          }, 1000)
    }
    
    
    setBeats(beats + 1)

  }
  const reset = () =>{
    clearInterval(countRef.current)
    setTime(0)
    setBeats(0)
    setStart(false)
  }

 
  
  const toggle = () => setModal(!modal);
  

  return (
    <div>
      <Button className='btn-info' onClick={toggle}>Heart Rate Monitor</Button>
      <Modal isOpen={modal} toggle={toggle} className='' style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Heart Rate Monitor</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">

                <div className="cardDisplay">
              
                
              <h2 className="name text-white"></h2>
              
                
                
             
             
              
              <div className="title"></div>
              
              <div className="actions">
              <div className="follow-info">
                <h2><a href="#">
                
                    
                    
                <span className="text-white" style={{fontSize:'20px'}}>{time}</span>
                    <small>Time </small>
                    
                    
                    
                    </a>
                </h2>
                    
                
              
                  
                  <h2><a href="#">
                     
                    {time> 5 ?  <span className="text-white" style={{fontSize:'20px'}}>{(beats*60/time).toFixed(0)}</span>
                    :
                    <span className="text-white" style={{fontSize:'20px'}}>--</span>
                    }
                    
                    
                    <small>Heart rate</small>
                    
                    <small> </small>
                    
                    
                    
                    </a>
                  </h2>
                  
                <h2><a href="#">
                <span className="text-white" style={{fontSize:'20px'}}>{beats}</span>
                    
                    
                <span className="text-white" style={{fontSize:'20px'}}></span>
                    <small>Beats </small>
                    
                    
                    
                    </a>
                </h2> 
                    
                    
                    
                
               
                
              </div>
              
              <div  className="follow-info" style={{alignItems:'center',justifyContent:'center'}}>
              
              </div>
                <div className="follow-btn">
                <Row >
                    <Col xs={4}sm={3} lg={3} md={3}>
                    <button className="text-white" onClick={e => clearInterval(countRef.current)}>Stop</button>
                    </Col>
                    <Col xs={4} sm={6} lg={6} md={6}>
                    <button className="text-white" onClick={monitor}>Beat</button>
                    </Col>
                    <Col  xs={4} sm={3} lg={3} md={3}>
                    <button className="text-white" onClick={reset}>Reset</button>
                    </Col>
                </Row>
                
                
                  
                </div>
              </div>
              
              
              <div className="desc"></div>
            </div>
            

  
        
          </div>
        </ModalBody>
        <ModalFooter  style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
        
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default HeartRateMonitor;